import { getEnvironmentConfig, getHttpClient, type sessionCookie } from '@repo/api';

/**
 * Web-specific API functions for session cookie management
 */

/**
 * Clear the session cookie via the local Next.js route.
 * This sets the HttpOnly cookie to maxAge=0 without calling the backend,
 * so it works even when the session is already expired or the backend is unreachable.
 */
export async function logoutWeb(): Promise<void> {
  const response = await fetch('/api/clear-session', { method: 'POST', credentials: 'include' });

  if (!response.ok) {
    throw new Error('Failed to clear session cookie');
  }
}

export function isFirstPartySessionHost(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'openigloo.com' || hostname.endsWith('.openigloo.com');
}

export function getSessionCookieUrl(): string {
  return isFirstPartySessionHost()
    ? `${window.location.origin}/api/session`
    : `${getEnvironmentConfig().endpoints.profile}/profile/session_cookie/`;
}

export function createSessionCookie(idToken: string) {
  return getHttpClient().request<Awaited<ReturnType<typeof sessionCookie>>>({
    method: 'POST',
    url: getSessionCookieUrl(),
    headers: { Authorization: `Bearer ${idToken}` },
  });
}
